<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-menu
    offset-y
    v-if="hasPermission"
    max-width="500"
    min-width="300"
    left
    class="white"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="font-weight-normal mr-4"
        v-on="on"
      >
        <span class="hidden-sm-and-down">
          {{ isAdmin ? 'Analisar acervos' : 'Acervos recusados' }}
        </span>
        <v-badge
          color="red"
          overlap
          small
        >
          <template v-slot:badge>
            <span v-if="notReaded.length > 0">{{ notReaded.length }}</span>
          </template>
          <v-icon class="ml-2">fas fa-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list
      dense
      max-height="400"
      class="white"
    >
      <v-list-item
        v-for="not in notificationsFiltered"
        two-line
        :key="not.id"
        :class="not.lida ? 'disabled' : 'accent white--text'"
        class="white"
        @click="readAndGo(not)"
      >
        <v-list-item-content>
          <v-list-item-title :class="not.lida ? 'disabled' : 'accent white--text'">
            <!-- eslint-disable-next-line max-len -->
            {{`${not.publicacao && not.publicacao.suporteBase[0] && not.publicacao.suporteBase[0].registro1.trim()} ${not.publicacao && not.publicacao.suporteBase[0] && not.publicacao.suporteBase[0].registro2.trim()}`}}
            - <strong>{{not.publicacao && not.publicacao.nome }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle :class="not.lida ? 'disabled' : 'accent white--text'">
            {{ new Date(not.createdAt)
              .toLocaleDateString('pt-BR', { hour: 'numeric', minute: 'numeric'} ) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!notifications.length">
        <v-list-item-title>Nenhuma notificação</v-list-item-title>
      </v-list-item>
      <infinite-loading
        class="white"
        @infinite="infiniteHandler"
      >
        <div slot="no-more">
          <v-list-item>
            <v-list-item-title>Nenhuma notificação</v-list-item-title>
          </v-list-item>
        </div>
        <div slot="no-results">
          <v-list-item>
            <v-list-item-title>Não há mais resultados</v-list-item-title>
          </v-list-item>
        </div>
      </infinite-loading>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    hasPermission: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    notifications: {
      type: Array,
      default: () => [],
    },
    readAndGo: {
      type: Function,
      default: () => {},
    },
    infiniteHandler: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    notReaded() {
      if (this.notifications.length) {
        return this.notifications.filter(not => !not.lida);
      }
      return [];
    },
    notificationsFiltered() {
      return this.notifications.filter(not => not.publicacao && not.publicacao.nome);
    },
  },
};
</script>
